<div class="full-width flex-utility direction-column align-center justify-center choose-event-page">
  <div class="choose-event-wrapper flex-utility direction-column align-left">
    <p class="choose-event-text"> {{ "PAGES.EVENT.SELECT_EVENT" | translate}} </p>
    <!-- <mat-form-field *ngIf="data.events.length > 0">
      <input matInput [(ngModel)]="searchText" autocomplete="off">

      <button *ngIf="searchText.length>0" matSuffix mat-icon-button aria-label="close" (click)="resetSearch()">
        <mat-icon>close</mat-icon>
      </button>

      <button matSuffix mat-icon-button aria-label="search" (click)="searchEvent()">
        <mat-icon>search</mat-icon>
      </button>

    </mat-form-field> -->
  </div>

  <mat-list>
    <mat-list-item *ngFor="let event of (filteredEvents.length > 0 ? filteredEvents : data.events)">
      <mat-list-item mat-line>
        <div matRipple (click)="hasSelectEvent(event)" class="event-option-container"
          [ngClass]="{'selected': isSelectedEvent(event)}">
          <div>
            <h4 class="text-title-event-option" [ngClass]="{'selected': isSelectedEvent(event)}">
              {{event.title | uppercase }} </h4>
          </div>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-list-item>

  </mat-list>
  <button matRipple (click)="confirmClick()" type="button" class="choose-event-button">
    {{('BUTTON.CHOOSE' | translate) | uppercase }}
  </button>
</div>
